import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus12() {
  return (
    <BusDetailsCard
      busId="bus12"
      title="Bus 12 - Route Details"
      busName="Bus 12"
      vehicleNo="TN74L2234"
      backTo="/?buses=1"
    />
  );
}